import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mb-8 text-3xl font-bold"
}, "Organizations", -1);
var _hoisted_2 = {
  "class": "flex items-center justify-between mb-6"
};
var _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700"
}, "Type:", -1);
var _hoisted_4 = /*#__PURE__*/_createElementVNode("option", {
  value: null
}, null, -1);
var _hoisted_5 = /*#__PURE__*/_createElementVNode("option", {
  value: "internal"
}, "Internal", -1);
var _hoisted_6 = /*#__PURE__*/_createElementVNode("option", {
  value: "external"
}, "External", -1);
var _hoisted_7 = [_hoisted_4, _hoisted_5, _hoisted_6];
var _hoisted_8 = {
  "class": "bg-white rounded-md shadow overflow-x-auto"
};
var _hoisted_9 = {
  "class": "w-full whitespace-nowrap"
};
var _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", {
  "class": "text-left font-bold"
}, [/*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "User Id"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Name"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Status"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "IS Manager"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Licenses"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, [/*#__PURE__*/_createElementVNode("div", null, "campaigns"), /*#__PURE__*/_createElementVNode("div", null, "(active/total)")]), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "joined at"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Activity Status")])], -1);
var _hoisted_11 = {
  "class": "border-t"
};
var _hoisted_12 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
var _hoisted_13 = {
  "class": "border-t"
};
var _hoisted_14 = {
  "class": "flex items-center px-6 py-4 focus:text-indigo-500"
};
var _hoisted_15 = {
  "class": "border-t"
};
var _hoisted_16 = {
  "class": "border-t"
};
var _hoisted_17 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
var _hoisted_18 = {
  "class": "border-t"
};
var _hoisted_19 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
var _hoisted_20 = {
  "class": "border-t"
};
var _hoisted_21 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
var _hoisted_22 = {
  "class": "border-t"
};
var _hoisted_23 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
var _hoisted_24 = {
  "class": "border-t"
};
var _hoisted_25 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
var _hoisted_26 = {
  key: 0
};
var _hoisted_27 = /*#__PURE__*/_createElementVNode("td", {
  "class": "px-6 py-4 border-t",
  colspan: "4"
}, "No organizations found.", -1);
var _hoisted_28 = [_hoisted_27];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_search_filter = _resolveComponent("search-filter");
  var _component_icon = _resolveComponent("icon");
  var _component_pagination = _resolveComponent("pagination");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Head, {
    title: "Organizations"
  }), _hoisted_1, _createElementVNode("div", _hoisted_2, [_createVNode(_component_search_filter, {
    modelValue: $data.form.search,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.form.search = $event;
    }),
    "class": "mr-4 w-full max-w-md",
    onReset: $options.reset
  }, {
    "default": _withCtx(function () {
      return [_hoisted_3, _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return $data.form.type = $event;
        }),
        "class": "form-select mt-1 w-full"
      }, _hoisted_7, 512), [[_vModelSelect, $data.form.type]])];
    }),
    _: 1
  }, 8, ["modelValue", "onReset"])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("table", _hoisted_9, [_hoisted_10, _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.organizations.data, function (organization) {
    return _openBlock(), _createElementBlock("tr", {
      key: organization.id,
      "class": "hover:bg-gray-100 focus-within:bg-gray-100"
    }, [_createElementVNode("td", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(organization.userId), 1)]), _createElementVNode("td", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createTextVNode(_toDisplayString(organization.name) + " ", 1), organization.deleted_at ? (_openBlock(), _createBlock(_component_icon, {
      key: 0,
      name: "trash",
      "class": "flex-shrink-0 ml-2 w-3 h-3 fill-gray-400"
    })) : _createCommentVNode("", true)])]), _createElementVNode("td", _hoisted_15, [_createElementVNode("div", {
      "class": _normalizeClass($options.getTenantStatusClass(organization.status)),
      tabindex: "-1"
    }, _toDisplayString(organization.status), 3)]), _createElementVNode("td", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(organization.isManager), 1)]), _createElementVNode("td", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(organization.licenses), 1)]), _createElementVNode("td", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(organization.campaigns), 1)]), _createElementVNode("td", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(new Date(organization.createdAt).toLocaleString()), 1)]), _createElementVNode("td", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(organization.activity_status), 1)])]);
  }), 128)), $props.organizations.data.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_26, _hoisted_28)) : _createCommentVNode("", true)])])]), _createVNode(_component_pagination, {
    "class": "mt-6",
    links: $props.organizations.links
  }, null, 8, ["links"])]);
}